var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-badge',{staticClass:"item",attrs:{"value":_vm.csrSelfOrderCnt}},[_c('el-button',{staticClass:"line-style-btn",attrs:{"size":"small"},on:{"click":_vm.openCrsSelfOrders}},[_vm._v("CSR Self-Order")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }